module.exports = __webpack_public_path__ + "assets/img/1adf62f6c7c1ec6c7dbf27a0cbcad908.png";